// relations 和 multi-relations 共用
import {
  importEvalRelation,
  getEvalsimpleusers,
  getEvalRelationsPage,
  addEvalTarget,
  getEvalConfigs,
  thirdImportPerson,
  userChooseAdd,
  userChooseDelete,
  postEvalRelationscheme
} from '../service.js';
import handleError from '../handleError';
import evalImportDrawer from './../components/eval-import-drawer';
import evalPager from './../components/eval-pager';
import evalSelectThirdpartyUser from './../components/eval-select-thirdparty-user';
import evalStepFooter from './../components/eval-step-footer';

export default {
  components: {
    yxtbizEvalImportDrawer: evalImportDrawer,
    yxtbizEvalPager: evalPager,
    yxtbizEvalSelectThirdpartyUser: evalSelectThirdpartyUser,
    yxtbizEvalStepFooter: evalStepFooter
  },
  mixins: [handleError],
  props: {
    id: {
      type: String,
      default: ''
    },
    fnValidMembers: {
      type: Function
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_addassessor_extent' /* 岗位地图-测评管理-人员管理选人 */
    },
    functionCode: {
      type: String,
      default: ''
    },
    getUsers: {
      type: Function
    },
    // 评估方案场景(1-胜任力 2-人格 3-通用)
    scene: {
      type: Number,
      default: 1
    },
    evaluatorDataPermission: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent'
    },
    type: {
      type: Number
    }
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      userListAll: [],
      isOpenEnv: false,
      keyword: '',
      loading: false,
      validate: false,
      pager: {
        limit: 20,
        offset: 0,
        total: 0,
        keyword: '',
        type: 1
      },
      operation: {
        disabled: false,
        nextDisabled: false,
        prev: this.prev,
        next: this.next,
        save: this.save,
        saveName: this.$t('pc_gwnl_global_btn_saveDraft' /* 保存草稿 */)
      },
      showImportButton: false,
      addUsersVisible: false, // 是否展示添加测评人员抽屉
      isSelfTest: false, // 是否只有自评
      relationList: [] // 所有评估关系的集合
    };
  },

  computed: {
    tempUrl() {
      const urlObj = {
        peer: { zh: '导入评估关系模板', en: 'importevaluatorstemplate', ha: '導入評估關係範本' },
        self: { zh: '导入自评人员模板', en: 'selfevaluationtemplate', ha: '導入自評人員範本' }
      };
      return this.isSelfTest ? urlObj.self : urlObj.peer;
    },

    // 批量导入的名称跟随是否是自评变化
    importBatchTitle() {
      return this.isSelfTest ? this.$t('pc_gwnl_global_btn_batchimport' /* 批量导入 */) : this.$t('pc_gwnl_global_btn_importEvalRelationship'/* 导入评估关系*/);
    }
  },

  methods: {
    init() {
      this.getList();
      this.getAllUsers();
      this.getEvalConfigs();
      this.isOpenEnv = this.checkOpenPlatform();
    },
    checkOpenPlatform() {
      const SOURCE_CODES = {
        weixin: '100',
        dingding: '104'
      };

      const isOpenPlatform = [SOURCE_CODES.weixin, SOURCE_CODES.dingding].includes(
        localStorage.sourceCode
      );

      return isOpenPlatform;
    },
    getList(page) {
      if (!this.id) return;
      const { limit, offset, keyword, type } = this.pager;
      this.loading = true;
      const params = {
        limit: limit,
        offset: page ? (page - 1) * limit : offset,
        keyword,
        type
      };
      getEvalRelationsPage(this.id, params).then(res => {
        this.tableData = res.datas;
        this.pager.offset = res.paging.offset;
        this.pager.total = res.paging.count;
        this.tableData.forEach(obj => {
          if (this.scene === 2) {
            // 人格评估默认补充自评信息
            obj.selfRelation = {
              evaluators: [{
                id: obj.userId,
                fullname: obj.fullname
              }],
              type: 1,
              weight: 100
            };
          }
          if (obj.customDimensionRelation) {
            obj.customDimensionRelation.forEach((item) => {
              obj['relation' + item.type] = item;
            });
          }
        });
        this.$nextTick(() => {
          this.$refs.multipleTable.$refs.multipleTable.clearSelection();
        });
        this.loading = false;
        this.validate = false; // 取消判空检验
      }).catch(err => {
        this.loading = false;
        this.handleError(err);
      });
    },
    getAllUsers() { // 获取全部人员接口
      getEvalsimpleusers(this.id).then(res => {
        this.userListAll = res.datas || [];
        this.userListAll.forEach(obj => {
          if (this.scene === 2) {
            // 人格评估默认补充自评信息
            obj.selfRelation = {
              evaluators: [{
                id: obj.userId,
                fullname: obj.fullname
              }],
              type: 1,
              weight: 100
            };
          }
        });
      }).catch(err => { this.handleError(err); });;
    },
    // 添加测评人员
    addEvalUsers() {
      this.addUsersVisible = true;
    },
    showImportRelation() {
      this.$refs.importRelation.show();
    },
    // 导入评估关系
    importMethods(file) {
      let formdata = new FormData();
      formdata.append('fileId', file.id);
      if (this.projectId) {
        formdata.append('projectId', this.projectId);
      }
      if (this.scene === 2) {
        // 和业务代码对齐，未发布导入第三方评估关系传1
        formdata.append('importType', 1);
        return thirdImportPerson(formdata, this.id);
      } else {
        return importEvalRelation(formdata, this.id);
      }
    },
    // 批量删除
    batchDeleteRow() {
      if (this.multipleSelection.length === 0) {
        this.$message.error(this.$t('pc_gwnl_eval_msg_selectPersonDeleted'));
        return false;
      }
      this.$confirm(this.$t('pc_gwnl_eval_msg_wantContinueOperation'), this.$t('pc_gwnl_eval_msg_personnelCannotRecovered'), {
        confirmButtonText: this.$t('pc_gwnl_eval_continue'),
        cancelButtonText: this.$t('pc_gwnl_global_msg_cancel'),
        type: 'warning'
      }).then(() => {
        let deleteUserIds = this.multipleSelection.map(item => { return { id: item.userId }; });
        userChooseDelete(this.id, { datas: deleteUserIds }).then(res => {
          this.getList(1);
          this.getAllUsers();
        }).catch(err => { this.handleError(err); });
      }).catch(() => { });
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    // 添加测评人员
    addEvalTargets(data) {
      this.loading = true;
      // 临时接口 没有真正保存
      addEvalTarget(this.id, { datas: data }).then(res => {
        this.loading = false;
        const successData = res.datas.map(item => {
          return {
            ...item,
            positionId: item.positionId || null,
            positionName: item.positionName || null
          };
        });
        userChooseAdd(this.id, { datas: successData }).then(() => {
          this.changeDatas(successData, res.failedCount);
        }).catch(err => { this.handleError(err); });
      }).catch((err) => {
        this.handleError(err);
        this.loading = false;
      });
    },
    // 获取配置信息
    getEvalConfigs() {
      getEvalConfigs(this.id).then(res => {
        this.showImportButton = res.enabledEqual === 1 ||
          res.enabledSubordinate === 1 ||
          res.enabledLeader === 1;

        // 是否仅有自评，来传递给组件判断
        this.isSelfTest = res.enabledSelf === 1 && res.weightSelf === 100;

        // 根据配置获取测评开启了哪些评估关系
        let relationList = [];
        const enabledList = [
          { key: 'enabledLeader', labelKey: 'pc_biz_eval_leaderRelation' },
          { key: 'enabledEqual', labelKey: 'pc_biz_eval_equalRelation' },
          { key: 'enabledSubordinate', labelKey: 'pc_biz_eval_subordinateRelation' }
        ];

        enabledList.forEach(item => {
          res[item.key] && relationList.push(this.$t(item.labelKey));
        });

        (res.customEvalConfigs || []).forEach(item => {
          relationList.push(item.dimensionName);
        });
        this.relationList = relationList;
      }).catch(err => {
        this.handleError(err);
      });
    },
    changeDatas(datas, failedCount) {
      let ids = this.userListAll.map(item => item.userId); // 页面已经存在的被评估人id列表
      let addDatas = []; // 本次选择新增的被评估人列表
      datas.forEach(data => {
        if (!ids.includes(data.userId)) {
          addDatas.push(data);
        }
      });
      if (addDatas.length > 0) {
        // `已成功添加${addDatas.length}名测评人员${failedCount > 0 ? `，失败${failedCount}名` : ''}`
        let msg1 = this.$t('pc_gwnl_eval_msg_testersSuccessAdded', { count: addDatas.length });
        let msg2 = failedCount > 0 ? this.$t('pc_gwnl_eval_msg_testersFailedAdded', { count: failedCount }) : '';
        this.$message.success(msg1 + msg2);
      }
      if (addDatas.length === 0 && failedCount > 0) {
        this.$message.error(this.$t('pc_gwnl_eval_msg_testersFailedAdded1', { count: failedCount }));
      }
      this.getList(1);
      this.getAllUsers();
    },
    // 处理选完人员
    handleSelectedUsers(users) {
      const data = users.map(item => {
        return {
          id: item.id || item.userId,
          name: item.fullname || item.name || item.userName,
          modelName: item.modelName,
          modelId: item.modelId
        };
      });
      this.addEvalTargets(data);
    },

    // 校验人员是否存在未勾选
    checkTableUser() {
      return this.$refs.multipleTable && this.$refs.multipleTable.validateDatas();
    },

    // 保存
    save() {
      if (!this.checkTableUser()) return;
      this.submit(1);
    },
    // 提交数据
    async submit(type) {
      if (this.fnValidMembers) {
        try {
          await this.fnValidMembers(this.userListAll);
        } catch (e) {
          console.log(e);
          return;
        }
      }
      this.setOperateVal(type, true);
      postEvalRelationscheme(this.id, { datas: [] }).then(res => {
        this.setOperateVal(type, false);
        if (type === 1) {
          this.$message.success(this.$t('pc_gwnl_global_msg_savedSuccessfully'));
        }
        if (type === 3) {
          this.$emit('next');
        }
      }).catch(err => {
        this.setOperateVal(type, false);
        this.handleError(err);
      });
    },
    // 下一步
    next() {
      if (!this.checkTableUser()) return;
      this.submit(3);
    },

    // 上一步
    prev() {
      this.$emit('prev');
    }
  }
};
